var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22617 11.2019C3.22617 11.2019 12.0717 7.57174 15.1395 6.29346C16.3155 5.78219 20.3036 4.14598 20.3036 4.14598C20.3036 4.14598 22.1443 3.4302 21.9909 5.16859C21.9398 5.88444 21.5307 8.38978 21.1217 11.0997C20.5081 14.9345 19.8434 19.1271 19.8434 19.1271C19.8434 19.1271 19.7412 20.3031 18.872 20.5076C18.0028 20.7122 16.5711 19.7919 16.3155 19.5873C16.1109 19.4339 12.4807 17.133 11.1513 16.0082C10.7934 15.7014 10.3844 15.0879 11.2024 14.372C13.0431 12.6847 15.2417 10.5884 16.5711 9.25905C17.1847 8.64545 17.7982 7.21382 15.2417 8.95221C11.6115 11.4576 8.0324 13.8096 8.0324 13.8096C8.0324 13.8096 7.21429 14.3209 5.68041 13.8607C4.14645 13.4006 2.3569 12.787 2.3569 12.787C2.3569 12.787 1.12985 12.0201 3.22617 11.2019Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramM);
export default __webpack_public_path__ + "static/media/telegram-m.fdcd88c18d676c6f35144baabe638f19.svg";
export { ForwardRef as ReactComponent };